import { WppButton, WppEmptyNoAccess, WppTypography } from '@wppopen/components-library-react'
import styles from './NotAuthorisedPage.module.scss'
import { Link } from 'react-router-dom'
import { EXTERNAL_LINKS } from 'utils/constants'

const NotAuthorisedPage = () => {
  return (
    <div className={styles.page} data-testid="not-authorised-page-container">
      <WppEmptyNoAccess />
      <WppTypography tag="h1" type="5xl-display" className={styles.heading}>
        Access denied
      </WppTypography>
      <WppTypography tag="h1" type="s-body" className={styles.text}>
        You don’t have permission to access the Commerce Studio PDP Generator.{' '}
      </WppTypography>
      <Link to={EXTERNAL_LINKS.WPP_OPEN_HOME} data-testid="link-to-wpp-open-home">
        <WppButton size="m" variant="primary">
          WPP Open Home
        </WppButton>
      </Link>
    </div>
  )
}

export default NotAuthorisedPage
